import Component from './message_queue_targets.vue'
export default Component
